import CodeBlocksCompiler from './CodeBlocksCompiler';
export default CodeBlocksCompiler;
